import React from 'react';
import PropTypes from 'prop-types';
import ID from 'helpers/id';
import './RadioButton.css';

const RadioButton = (props) => {
  const id = ID();

  return (
    <label className="radio-button" htmlFor={id}>
      <span className="radio-button__label">{props.text}</span>
      <input
        id={id}
        type="radio"
        checked={props.checked}
        onClick={props.onClick}
        readOnly={props.readOnly}
        required={props.required}
        name={props.name}
      />
      <span className="radio-button__checkmark" />
    </label>
  );
};

RadioButton.propTypes = {
  checked: PropTypes.bool,
  text: PropTypes.string,
  onClick: PropTypes.func,
  readOnly: PropTypes.bool,
  required: PropTypes.bool,
  name: PropTypes.string,
};

RadioButton.defaultProps = {
  checked: false,
  readOnly: true,
};

export default RadioButton;



// WEBPACK FOOTER //
// ./src/components/RadioButton/RadioButton.jsx